import * as types from "../ActionType";

const initState = {
    statistics: {},
    loadingStatistics: true
}

const StatisticsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_STATISTICS:
            return { ...state, statistics: action.payload, loadingStatistics: false }
        default:
            return state;
    }
};

export default StatisticsReducer;
